module.exports = __webpack_public_path__ + "static/media/js-beginner.8d151bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/js-beginner.png
// module id = 1458
// module chunks = 146